/// <reference path='../../../typings/browser.d.ts' />

namespace Application.Controllers {
  'use strict';

  import ConnectionRoom = Models.ConnectionRoom;
  import IBlock = Application.Models.IBlock;
  import INetworkNode = Application.Models.INetworkNode;

  export interface IRetakeModalScope extends ng.IScope {
    blocksInfo: any;
    isPresetPath: boolean;
    retakeOrigin: string;
    modalClose: () => void;
    retake: () => void;
    updatingPass:(newPassphrase: any) => void;
    changeModifyPassphrase: () => void;
    loading: boolean;
    passphrase: string;
    modifyPassphrase: boolean;
    disablePassphraseMod: boolean;
    passphraseError: boolean;
  }

  /**
   * RetakeController class
   */
  export class RetakeController {
    public static templateURL: string = 'decorators/modals/retake-modal.html';
    public static ID: string = '#id-retake-modal';
    public static $name: string = 'retakeModalController';
    public connectionRooms: ConnectionRoom[];
    public static $inject: string[] = [
      '$scope',
      'close',
      '$interval',
      '$timeout',
      'blocksInfo',
      'isPresetPath',
      'retakeOrigin',
      '$window',
      'connectionRoomService',
      'blockConnectionBlocksService',
      '$rootScope',
      'ModalService',
      'blockService',
    ];

    private scope: IRetakeModalScope;
    private $interval: ng.IIntervalService;
    private close: (parameters: ngModal.ICloseParameters) => void;

    /**
     * Constructor
     */
    constructor(
        $scope: IRetakeModalScope,
        close: (parameters: ngModal.ICloseParameters) => void,
        $interval: ng.IIntervalService,
        $timeout: ng.ITimeoutService,
        blocksInfo: any,
        isPresetPath: boolean,
        retakeOrigin: string,
        private $window: ng.IWindowService,
        private connectionRoomService: Services.ConnectionRoomService,
        private blockConnectionBlockService: Services.BlockConnectionBlocksService,
        private $rootScope: Services.IFlexSettings,
        private modalService: ngModal.IModalService,
        private blockService: Services.BlockService,
    ) {
      this.scope = $scope;
      this.scope.loading = false;
      this.$interval = $interval;
      this.scope.blocksInfo = blocksInfo;
      this.scope.passphrase = retakeOrigin == 'decoder' ? blocksInfo[1].blockConnection.origBlockConnection.parameters.passphrase : blocksInfo[0].blockConnection.destBlockConnection.parameters.passphrase;
      this.scope.retakeOrigin = retakeOrigin;
      this.scope.passphraseError = false;
      this.scope.modifyPassphrase = false;
      this.scope.isPresetPath = isPresetPath;
      this.scope.disablePassphraseMod = this.scope.isPresetPath;
      

      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      this.close = close;

      this.scope.modalClose = (): void => {
        this.close(undefined);
      };

      this.scope.retake = async (): Promise<void> => {
        this.scope.loading = true;
        if (this.scope.modifyPassphrase) {
            await this.updatePassphrase();
        }
        await this.dropThenTake();
      };

      this.scope.updatingPass = (newPassphrase: any): void => {
        this.checkPassphrase(newPassphrase);
        this.scope.passphrase = this.scope.passphraseError ? this.scope.passphrase : newPassphrase;
      }

      this.scope.changeModifyPassphrase = (): void => {
        this.scope.modifyPassphrase = !this.scope.modifyPassphrase;
      };

      if(this.scope.isPresetPath) {
        this.setDisablePassphraseMod();
      }
    }

    async setDisablePassphraseMod() {
      let node = await this.blockService.getNodeFromBlockName(this.getCurrentBlockConnection().blockName);
      this.scope.disablePassphraseMod = node.config.disablePassphraseMod;
    }

    async updatePassphrase() {
      let blockConnectionToUpdate = this.getCurrentBlockConnection();
      const updatedBlockConnection: Models.IUpdateBlockConnection = {
        id: blockConnectionToUpdate.id,
        targetPorts: blockConnectionToUpdate.targetPorts,
        parameters: {passphrase: this.scope.passphrase},
      };
      await this.blockConnectionBlockService
          .updateBlockConnection(updatedBlockConnection);
    }

    /**
     * depending on retake origin, the block Connection we're using
     * will be different
     */
    getCurrentBlockConnection(){
      return this.scope.retakeOrigin == 'decoder' ? this.scope.blocksInfo[1].blockConnection.origBlockConnection : 
      this.scope.blocksInfo[0].blockConnection.destBlockConnection;
    }

    checkPassphrase(newPassphrase: string) {
      this.scope.passphraseError = !newPassphrase || newPassphrase.length < 10 || this.validatePassphraseChars(newPassphrase);
    }

    validatePassphraseChars(passphrase: string) {
      return passphrase.indexOf('=') !== -1 || passphrase.indexOf('&') !== -1 || passphrase.indexOf('?') !== -1;
    }

    async dropThenTake() {
      let block: any = await (await this.getConnRooms([this.scope.blocksInfo[1].blockConnection.destBlock]));
      block = block[0];
      await this.connectionRoomService.drop(block.connRooms[0], block.id, true);
      let validation = await this.connectionRoomService.validateConnection(this.scope.blocksInfo[0].blockConnection.origBlock.id, block.id, undefined);
      if (validation.result === 'OK' || validation.result === 'WARNING') {
        this.$rootScope.$broadcast('vars.connectionLocked', true);
        await this.connectionRoomService.take(block.connRooms[0], this.scope.blocksInfo[0].blockConnection.origBlock.id, block.id);
        this.$window.location.href = '/#!/matrix-room';
        this.reTake(this.scope.blocksInfo[0].blockConnection.origBlock.name, block.name, block.id, this.scope.modifyPassphrase ? this.scope.passphrase: undefined);
      }
    }
    public async getConnRooms(selectedBlocks: IBlock[]) {
      const connRooms = await this.connectionRoomService.getAllConnRoomsPromise();
      selectedBlocks.forEach((block: IBlock) => {
        block.connRooms = [];
        connRooms.forEach((room) => {
          if (
            room.blockHrefs.some((blockHref) => {
              return blockHref.blockHref == block.id.toString();
            })
          ) {
            block.connRooms.push(room);
          }
        });
      });
      return selectedBlocks;
    }

    public reTake(source: string, sinkName: string, sinkId: number, passphrase: string): void {
      this.modalService.showModal({
        templateUrl: Application.Controllers.RetakeDoneController.templateURL,
        controller: Application.Controllers.RetakeDoneController.$name,
        inputs: {
          retakeInfo: 'Re take done ' + source + " > " + sinkName,
          passphraseInfo: passphrase ? "With passphrase " + passphrase : "",
          sink: sinkId,
        },
      }).then((modal: ngModal.IModalObject) => {
        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.RetakeDoneController.ID,
            {bgclose: false, modal: false, keyboard: false});
        modalElem.show();
        modal.close.then((result2: Object) => {
          modalElem.hide();
        });
      });
    }
  }
}
